import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function simpleNameOf(type) {
  var tmp0 = type.get_simpleName_r6f8py_k$();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.checkNotNull' call
    if (tmp0 == null) {
      var message = "Getting simple name of '" + toString(type) + "' shouldn't return 'null'.";
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
    } else {
      tmp$ret$0 = tmp0;
      break $l$block;
    }
  }
  return tmp$ret$0;
}
//region block: exports
export {
  simpleNameOf as simpleNameOf1k8hddecfy128,
};
//endregion

//# sourceMappingURL=KClassX.mjs.map
